export var Header;
(function (Header) {
    Header["AppDomain"] = "X-Appdomainid";
    Header["Locale"] = "Accept-Language";
    Header["SalesChannel"] = "X-Sales-Channel";
})(Header || (Header = {}));
export var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["Large"] = 762] = "Large";
    ImageSize[ImageSize["Medium"] = 375] = "Medium";
    ImageSize[ImageSize["Small"] = 284] = "Small";
    ImageSize[ImageSize["ExtraSmall"] = 173] = "ExtraSmall";
    ImageSize[ImageSize["Thumbnail"] = 62] = "Thumbnail";
})(ImageSize || (ImageSize = {}));
export var PRODUCTION_LOCAL_CONTENTFUL_URL = 'https://pegasus-proxy-skipper.zlounge.zalan.do/proxy/contentful';
export var PRODUCTION_CONTENTFUL_URL = 'http://lounge-contentful-proxy.ingress.cluster.local';
